import { Injectable, TemplateRef } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Custom,
  Container,
  TablaMaestra,
  Option
} from '@app/shared';


@Injectable()
export class MasterAccessControlFormsService {
  constructor() { }

  /**
   * Formatea la lista de maestras por una lista de opciones para el selector
   *
   * @param {Array<TablaMaestra>} masterTables
   * @returns {Array<Option>}
   * @memberof MasterAccessControlFormsService
   */
  setMasterTables(masterTables: Array<TablaMaestra>): Array<Option> {
    const masterT: Array<any> = [];
    masterTables.forEach(mt => {
      masterT.push({
        key: mt.id,
        value: mt.nombre
      });
    });
    return masterT;
  }

  /**
   * Retorna los controles del formulario
   *
   * @param {TemplateRef<any>} template
   * @param {Array<TablaMaestra>} masterTables
   * @param {*} [data]
   * @returns {BaseControl<any>[]}
   * @memberof MasterAccessControlFormsService
   */
  getForm(template: TemplateRef<any>, masterTables: Array<TablaMaestra>, data?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboMasterTable',
        order: 1,
        label: 'Cargar información de la tabla Maestra:',
        template: template,
        placeholder: 'Seleccione la tabla maestra de donde se cargaran las opciones',
        options: this.setMasterTables(masterTables),
        value: data ? data.id_maestra ? data.id_maestra : null : null,
        validations: {
          validators: [Validators.required]
        },
        size: 'col-12',
      }),
      new Container({
        class: 'form-row',
        order: 2,
        controls: [
          new Textbox({
            key: 'chAgregar',
            type: 'checkbox',
            value: data ? data.agregar ? data.agregar : false : false,
            label: 'Agregar registros',
            size: 'col-12 col-md-3',
          }),
          new Textbox({
            key: 'chModificar',
            type: 'checkbox',
            value: data ? data.modificar ? data.modificar : false : false,
            label: 'Modificar registros',
            size: 'col-12 col-md-3',
          }),
          new Textbox({
            key: 'chEliminar',
            type: 'checkbox',
            value: data ? data.eliminar ? data.eliminar : false : false,
            label: 'Eliminar registros',
            size: 'col-12 col-md-3',
          }),
        ],
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/master-access-control/shared/master-access-control.form.service.ts